module.exports = __webpack_public_path__ + "static/media/dimensions-reinforced.0ac3adec.png";